export const mvImages = () => {
  if (!document.querySelector(".js-mv-images")) return;

  setTimeout(() => {
    const el = document.querySelector(".js-mv-images");
    if (el) {
      el.setAttribute("data-active-group", "1");
    }

    // 6秒ごとに値を切り替える
    setInterval(() => {
      const el = document.querySelector(".js-mv-images");
      if (el) {
        const current = el.getAttribute("data-active-group");
        const newValue = current === "1" ? "2" : "1";
        el.setAttribute("data-active-group", newValue);
      }
    }, 6000);
  }, 500);
};
